import React, { useState } from "react";
import {
  Box,
  Modal,
  Typography,
  Button,
  Card,
  CardContent,
  Avatar,
  Grid,
} from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import { useTheme } from "@mui/material/styles";
import { tokens } from "../../../theme";

const UserSessionModal = ({ open, onSelectUser }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [selectedUser, setSelectedUser] = useState(null);

  const users = [
    { name: "David Acevedo", color: "#1976d2", image: "/david.jpg" },
    { name: "Vannesa Santamaria", color: "#5b00aa", image: "/vannesa.jpg" },
  ];

  const handleUserClick = (userName) => {
    setSelectedUser(userName);
  };

  const handleConfirm = () => {
    if (selectedUser) {
      localStorage.setItem("currentUser", selectedUser);
      onSelectUser(selectedUser);
    }
  };

  return (
    <Modal
      open={open}
      disableEscapeKeyDown
      sx={{
        backdropFilter: "blur(3px)",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "90%", sm: "500px" },
          bgcolor: colors.grey[900],
          borderRadius: 3,
          boxShadow: 24,
          p: 4,
        }}
      >
        <Typography
          variant="h4"
          component="h2"
          sx={{ mb: 3, textAlign: "center", fontWeight: "bold" }}
        >
          ¿Quién está entrenando?
        </Typography>
        <Typography
          variant="body1"
          sx={{ mb: 3, textAlign: "center", color: colors.grey[300] }}
        >
          Selecciona tu usuario para continuar
        </Typography>

        <Grid container spacing={2} sx={{ mb: 3 }}>
          {users.map((user) => (
            <Grid item xs={12} key={user.name}>
              <Card
                onClick={() => handleUserClick(user.name)}
                sx={{
                  cursor: "pointer",
                  border:
                    selectedUser === user.name
                      ? `3px solid ${user.color}`
                      : `2px solid ${colors.grey[700]}`,
                  transition: "all 0.3s ease",
                  "&:hover": {
                    transform: "scale(1.02)",
                    boxShadow: `0 4px 20px ${user.color}50`,
                  },
                }}
              >
                <CardContent
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    py: 2,
                  }}
                >
                  <Avatar
                    sx={{
                      bgcolor: user.color,
                      width: 56,
                      height: 56,
                    }}
                    src={user.image}
                    alt={user.name}
                  >
                    <PersonIcon sx={{ fontSize: 32 }} />
                  </Avatar>
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                      {user.name}
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        <Button
          variant="contained"
          fullWidth
          size="large"
          disabled={!selectedUser}
          onClick={handleConfirm}
          sx={{
            py: 1.5,
            fontSize: "0.875rem",
            fontWeight: "bold",
          }}
        >
          Confirmar Usuario
        </Button>
      </Box>
    </Modal>
  );
};

export default UserSessionModal;
